module.exports = __webpack_public_path__ + "7806d3f65cfe95ff1cb61e88dcc6341d.png";